module.exports = __webpack_public_path__ + "static/media/dH20-empty-open.e82f7565.svg";